import { createContext, useContext } from 'react';

export const UserUploadFileNameContext = createContext<string>('');

export const UserUploadFileNameProvider = UserUploadFileNameContext.Provider;

export const useUserUploadFileName = () => useContext(UserUploadFileNameContext);
